import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import { TopbarContainer } from '../../containers';
import { findOptionsForSelectFilter } from '../../util/search';
import {
  PageBootstrap,
  LayoutWrapperFooter,
  Footer,
  NavigationBar,
  ActivitiesSection,
} from '../../components';
import  './ExperiencesPage.scss';
import { injectIntl, intlShape } from '../../util/reactIntl';

import { propTypes } from '../../util/types';



const ExperiencesPageComponent = ({ experienceGroups, currentUser }) => {
  const filterConfig = config.custom.filters;
  const activitiesOptions = findOptionsForSelectFilter('activities', filterConfig);


  return (
    <PageBootstrap
      description="Experiences page"
      title="Experiences"
      schema={{
           '@context': 'http://schema.org',
           '@type': 'ExperiencesPage',
           description: 'Experiences',
           name: 'Experiences page',
         }}>
      <TopbarContainer />
      <NavigationBar title="Experiences"/>
      <ActivitiesSection activitiesOptions={activitiesOptions} experienceGroups={experienceGroups}/>

      <LayoutWrapperFooter>
          <Footer showBanner={false} />
      </LayoutWrapperFooter>

    </PageBootstrap>
  );
};

ExperiencesPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { data, fetchDataError } = state.ExperiencesPage;
  const experienceGroups = data?.data ? data.data : {};
  return {
    currentUser,
    experienceGroups,
  };
};

const ExperiencesPage = compose(connect(mapStateToProps), injectIntl)(ExperiencesPageComponent);

export default ExperiencesPage;
